import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg, { organizationSchema, websiteSchema, buildBreadcrumbSchema, buildFaqSchema } from '@/components/feature/SchemaOrg';
import AboutContent from './components/AboutContent';

const aboutFaqs = [
  {
    question: '凪光在线观看是完全免费的吗？',
    answer: '是的，凪光在线观看完全免费。我们坚持「免费、高清、及时」的核心理念，不设置任何会员门槛或隐藏收费，所有内容均可免费在线观看。',
  },
  {
    question: '凪光系列目前有几季？',
    answer: '凪光系列目前已推出第一季（24话，已完结）、第二季「深海之章」（24话，连载中）、剧场版「永恒之约」以及OVA特典「夏日的回忆」和「冬日的约定」。第三季已正式宣布制作，预计2027年播出。',
  },
  {
    question: '如何在手机上观看凪光？',
    answer: '凪光在线观看完美支持移动端播放，您只需在手机浏览器中打开我们的网站即可直接观看，无需下载任何App。我们的播放器已针对移动端进行优化，确保触屏操作流畅便捷。',
  },
  {
    question: '凪光的中文字幕是官方翻译吗？',
    answer: '我们采用专业翻译团队精心制作的中文字幕，确保翻译准确、表达自然。所有字幕均经过多轮校对和润色，力求为观众呈现最佳的中文观影体验。',
  },
];

export default function AboutPage() {
  const breadcrumbItems = [{ label: '首页', to: '/' }, { label: '关于我们' }];

  return (
    <>
      <SchemaOrg type="Organization" data={organizationSchema} />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="WebPage" data={{
        name: '关于我们 - 凪光在线观看',
        url: 'https://subtitlesjp.github.io/about',
        breadcrumb: { '@type': 'BreadcrumbList', ...buildBreadcrumbSchema([{ name: '首页', url: '/' }, { name: '关于我们' }]) },
      }} />
      <SchemaOrg type="BreadcrumbList" data={buildBreadcrumbSchema([{ name: '首页', url: '/' }, { name: '关于我们' }])} />
      <SchemaOrg type="FAQPage" data={buildFaqSchema(aboutFaqs.map(f => ({ question: f.question, answer: f.answer })))} />

      <div className="mx-auto max-w-[1400px] px-4 md:px-6 pt-6">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <AboutContent />
    </>
  );
}